import React from "react";
import * as Icons from "lucide-react";

/**
 * Renders a Lucide icon by name inside a tinted teal circular badge.
 * Props:
 *   name       — Lucide component name (e.g. "Compass")
 *   selected   — when true, badge glows and icon switches to the solid teal.
 *   size       — badge diameter in px (default 44)
 *   tone       — "teal" | "amber" | "red"
 */
export function OptionIcon({
    name,
    selected = false,
    size = 44,
    tone = "teal",
    className = "",
    iconSize,
    strokeWidth = 2,
}) {
    const Icon = Icons[name] ?? Icons.Circle;
    const px = iconSize ?? Math.round(size * 0.5);

    const toneBadge = {
        teal: selected
            ? "bg-klareet-T/25 shadow-[0_0_0_6px_rgba(20,184,166,0.12)]"
            : "bg-klareet-T/12",
        amber: selected
            ? "bg-klareet-AMBER/25 shadow-[0_0_0_6px_rgba(245,158,11,0.12)]"
            : "bg-klareet-AMBER/12",
        red: selected
            ? "bg-klareet-RED/25 shadow-[0_0_0_6px_rgba(239,68,68,0.12)]"
            : "bg-klareet-RED/12",
    }[tone];

    const iconTone = {
        teal: "text-klareet-T2",
        amber: "text-klareet-AMBER",
        red: "text-klareet-RED",
    }[tone];

    return (
        <span
            className={`inline-flex items-center justify-center rounded-full transition-colors duration-300 ${toneBadge} ${className}`}
            style={{ width: size, height: size }}
            aria-hidden
        >
            <Icon
                size={px}
                strokeWidth={strokeWidth}
                className={iconTone}
            />
        </span>
    );
}
